import { useEffect } from 'react'
import { useRouter } from 'next/router'
import CompaniesHeader from '@/components/companies/header/header'
import CompaniesToolbar from '@/components/companies/toolbar/toolbar'
import CompaniesTable from '@/components/companies/table/companies-table'
import { useCrmStore } from '@/stores/crm-store-provider'

export default function Companies() {
    const router = useRouter()
    const setOwner = useCrmStore(state => state.setOwner)
    const ownerQuery = typeof router.query.owner === 'string' ? router.query.owner : null

    useEffect(() => {
        if (ownerQuery) setOwner(ownerQuery)
    }, [ownerQuery, setOwner])

    return (
        <section id='companies' className='flex min-h-0 min-w-0 flex-1 flex-col'>
            <CompaniesHeader />
            <CompaniesToolbar />
            <CompaniesTable />
        </section>
    )
}
